"use client";

import { c as _c } from "react/compiler-runtime";
import { readFragment } from "@opensea/graphql";
import { classNames, FlexCenter } from "@opensea/ui-kit";
import { ProfileMetadataChip } from "./ProfileMetadataChip";
import { ProfileMetadataChipsFragment } from "./ProfileMetadataChips.fragment";
export function ProfileMetadataChips(t0) {
  const $ = _c(23);
  let children;
  let className;
  let profileKey;
  let rest;
  let t1;
  if ($[0] !== t0) {
    ({
      profile: profileKey,
      chips: t1,
      children,
      className,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = profileKey;
    $[4] = rest;
    $[5] = t1;
  } else {
    children = $[1];
    className = $[2];
    profileKey = $[3];
    rest = $[4];
    t1 = $[5];
  }
  let t2;
  if ($[6] !== t1) {
    t2 = t1 === undefined ? ["joined_at", "address", "ens_name", "beta_tester", "coinbase_one", "is_staff"] : t1;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  const chips = t2;
  let t3;
  if ($[8] !== profileKey) {
    t3 = readFragment(ProfileMetadataChipsFragment, profileKey);
    $[8] = profileKey;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  const profile = t3;
  let t4;
  if ($[10] !== className) {
    t4 = classNames("w-full gap-2", className);
    $[10] = className;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== chips || $[13] !== profile || $[14] !== rest) {
    let t6;
    if ($[16] !== profile || $[17] !== rest) {
      t6 = chip => <ProfileMetadataChip chip={chip} key={chip} profile={profile} {...rest} />;
      $[16] = profile;
      $[17] = rest;
      $[18] = t6;
    } else {
      t6 = $[18];
    }
    t5 = chips.map(t6);
    $[12] = chips;
    $[13] = profile;
    $[14] = rest;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  let t6;
  if ($[19] !== children || $[20] !== t4 || $[21] !== t5) {
    t6 = <FlexCenter className={t4}>{t5}{children}</FlexCenter>;
    $[19] = children;
    $[20] = t4;
    $[21] = t5;
    $[22] = t6;
  } else {
    t6 = $[22];
  }
  return t6;
}